import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../services/api';
import ClientSidenav from '../components/ClientSidenav';
import './Cursos.css';


const CATEGORIES = [
  { id: 'all',        label: 'Todos',           icon: '◈' },
  { id: 'aws',        label: 'AWS',              icon: '☁' },
  { id: 'iac',        label: 'IaC',              icon: '⬡' },
  { id: 'cicd',       label: 'CI/CD',            icon: '↺' },
  { id: 'automacao',  label: 'Automação',        icon: '⚡' },
  { id: 'database',   label: 'Banco de Dados',   icon: '⬢' },
  { id: 'containers', label: 'Containers',       icon: '◻' },
  { id: 'devops',     label: 'DevOps',           icon: '⚙' },
];


function Cursos() {
  const location = useLocation();
  const navigate = useNavigate();
  const [user] = useState(location.state?.user || JSON.parse(localStorage.getItem('user_data') || 'null'));
  const [token] = useState(localStorage.getItem('auth_token'));

  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState('grid');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    if (!user || !token) { navigate('/treinamentos'); return; }
    loadData();

    const onVisibility = () => { if (!document.hidden) loadData(); };
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, []);

  useEffect(() => {
    let list = [...courses];
    if (selectedCategory !== 'all') {
      list = list.filter(c => (c.category || '').toLowerCase().includes(selectedCategory));
    }
    if (searchTerm.trim()) {
      const q = searchTerm.toLowerCase();
      list = list.filter(c =>
        (c.title || c.name || '').toLowerCase().includes(q) ||
        (c.description || '').toLowerCase().includes(q) ||
        (c.category || '').toLowerCase().includes(q)
      );
    }
    setFilteredCourses(list);
  }, [courses, searchTerm, selectedCategory]);

  const loadData = async () => {
    try {
      setLoading(true);
      const [coursesRes, enrollmentsRes] = await Promise.all([
        api.get('/courses', false),
        api.get('/enrollments', true),
      ]);
      if (coursesRes.success) setCourses(coursesRes.data);
      if (enrollmentsRes.success) setEnrollments(enrollmentsRes.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const isEnrolled = (courseId) => enrollments.some(e => e.courseId === courseId);

  const handleEnroll = async (course) => {
    if (course.price > 0) { alert('Funcionalidade de pagamento em desenvolvimento'); return; }
    try {
      const courseId = course.id || course.PK?.replace('COURSE#', '');
      const res = await api.post('/enrollments', { courseId }, true);
      if (res.success) { alert(`${user.name}, você se inscreveu em: ${course.title || course.name}`); loadData(); }
    } catch (e) { alert(e.message || 'Erro ao se inscrever'); }
  };

  const handleAccessCourse = (course) => {
    navigate(`/treinamentos/curso/${course.id || course.PK?.replace('COURSE#', '')}`);
  };

  if (!user || !token) return null;

  const firstName = user.name?.split(' ')[0] || 'você';

  return (
    <div className="cursos-page">

      <ClientSidenav />

      {/* ── HERO BANNER ── */}
      <section className="cursos-hero">
        <div className="cursos-hero-orb orb-1" />
        <div className="cursos-hero-orb orb-2" />
        <div className="cursos-hero-inner">
          <p className="cursos-hero-eyebrow">Bem-vindo de volta, {firstName} 👋</p>
          <h1 className="cursos-hero-title">Catálogo de <span>Cursos</span></h1>
          <p className="cursos-hero-sub">Acelere sua carreira em cloud, DevOps e infraestrutura com conteúdo de nível profissional.</p>

          {/* Search */}
          <div className="cursos-search">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
            </svg>
            <input
              type="text"
              placeholder="Buscar cursos por nome, tecnologia ou categoria…"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button className="cursos-search-clear" onClick={() => setSearchTerm('')}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}><path d="M18 6L6 18M6 6l12 12" /></svg>
              </button>
            )}
          </div>
        </div>
      </section>

      {/* ── CONTROLS ── */}
      <div className="cursos-controls">
        <div className="cursos-controls-inner">
          {/* Category pills */}
          <div className="cursos-cats">
            {CATEGORIES.map(cat => (
              <button
                key={cat.id}
                className={`cursos-cat ${selectedCategory === cat.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(cat.id)}
              >
                <span className="cat-icon">{cat.icon}</span>
                {cat.label}
              </button>
            ))}
          </div>

          {/* Right: count + view toggle */}
          <div className="cursos-controls-right">
            <span className="cursos-count">
              {loading ? '…' : `${filteredCourses.length} ${filteredCourses.length === 1 ? 'curso' : 'cursos'}`}
            </span>
            <div className="view-toggle">
              <button className={viewMode === 'grid' ? 'active' : ''} onClick={() => setViewMode('grid')} title="Grade">
                <svg viewBox="0 0 24 24" fill="currentColor"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>
              </button>
              <button className={viewMode === 'list' ? 'active' : ''} onClick={() => setViewMode('list')} title="Lista">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}><line x1="9" y1="6" x2="20" y2="6"/><line x1="9" y1="12" x2="20" y2="12"/><line x1="9" y1="18" x2="20" y2="18"/><circle cx="4" cy="6" r="1.5" fill="currentColor"/><circle cx="4" cy="12" r="1.5" fill="currentColor"/><circle cx="4" cy="18" r="1.5" fill="currentColor"/></svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── COURSE LIST ── */}
      <main className="cursos-main">
        {loading ? (
          <div className="cursos-loading">
            <div className="cursos-spinner" />
            <p>Carregando cursos…</p>
          </div>
        ) : filteredCourses.length === 0 ? (
          <div className="cursos-empty">
            <div className="cursos-empty-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5}><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
            </div>
            <h3>Nenhum curso encontrado</h3>
            <p>Tente ajustar sua busca ou escolher outra categoria.</p>
            <button onClick={() => { setSearchTerm(''); setSelectedCategory('all'); }}>Limpar filtros</button>
          </div>
        ) : (
          <div className={`cursos-grid cursos-${viewMode}`}>
            {filteredCourses.map(course => {
              const courseId = course.id || course.PK?.replace('COURSE#', '');
              const enrolled = isEnrolled(courseId);
              const isFree = course.price === 0 || course.isFree;
              const discount = course.originalPrice > 0
                ? Math.round((1 - course.price / course.originalPrice) * 100) : 0;

              return (
                <article key={courseId} className={`course-card ${enrolled ? 'enrolled' : ''}`}>
                  {/* Thumbnail */}
                  <div className="course-thumb">
                    {course.coverImage
                      ? <img src={course.coverImage} alt={course.title || course.name} />
                      : <div className="course-thumb-placeholder">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.2}><path d="M15 10l4.553-2.069A1 1 0 0121 8.87v6.26a1 1 0 01-1.447.894L15 14M3 8a2 2 0 012-2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"/></svg>
                        </div>
                    }
                    <span className={`course-badge ${isFree ? 'badge-free' : 'badge-paid'}`}>
                      {isFree ? 'Gratuito' : 'Premium'}
                    </span>
                    {enrolled && <div className="course-enrolled-ribbon">✓ Inscrito</div>}
                  </div>

                  {/* Body */}
                  <div className="course-body">
                    {course.category && (
                      <span className="course-category">{course.category}</span>
                    )}
                    <h3 className="course-title">{course.title || course.name}</h3>
                    <p className="course-desc">{course.description}</p>

                    {course.duration && (
                      <div className="course-meta">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                        {course.duration}
                      </div>
                    )}
                  </div>

                  {/* Footer */}
                  <div className="course-foot">
                    <div className="course-price-block">
                      {isFree ? (
                        <span className="price-free">Grátis</span>
                      ) : (
                        <div className="price-paid">
                          {discount > 0 && (
                            <>
                              <span className="price-original">R$ {course.originalPrice.toFixed(2)}</span>
                              <span className="price-discount-tag">-{discount}%</span>
                            </>
                          )}
                          <span className="price-current">R$ {course.price.toFixed(2)}</span>
                        </div>
                      )}
                    </div>

                    {enrolled ? (
                      <button className="btn-access" onClick={() => handleAccessCourse(course)}>
                        Acessar
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}><path d="M9 18l6-6-6-6"/></svg>
                      </button>
                    ) : (
                      <button
                        className={isFree ? 'btn-enroll-free' : 'btn-enroll-paid'}
                        onClick={() => handleEnroll(course)}
                      >
                        {isFree ? 'Inscrever-se' : 'Comprar'}
                      </button>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </main>

      <footer className="cursos-footer">
        <p>© 2026 Cloud Cafe & DevOps · Todos os direitos reservados</p>
      </footer>
    </div>
  );
}

export default Cursos;
